import React from "react";

export default function Index({ text }) {
    return <h3 className="bg-secondary mx-auto md:mx-0 w-fit px-6 font-extrabold subheading py-2 text-xs rounded-3xl">{text}</h3>;
}
